import type React from 'react';

import { TextField } from '@change/ds-forms';

import { useTitleData } from './hooks';

export const Title: React.FC = () => {
	const { data, actions } = useTitleData();

	return (
		<div id="edit_ask" className="pt-6">
			<TextField
				type="text"
				label=""
				size="large"
				name="title-input"
				value={data.value}
				errorMessage={data.error}
				onChange={actions.handleChange}
				placeholder="Your headline here"
				data-qa="title-textfield"
				maxLength={90}
				isRequired
			/>
		</div>
	);
};
